"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryCheckboxOption = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _core = require("./core");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["classes"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c579813cb{display:flex;transition:opacity var(--animation-timing-def) ease}.c579813cb:hover:not(.cf92da023){cursor:pointer}.c579813cb:hover:not(.cf92da023) .c39df044e{cursor:pointer}.c579813cb:hover:not(.cf92da023) .c047e248f{background:#e2e9f9;border:.0625rem solid #4676d9}.c7e5f3f95{display:none}.ce2f30499 .c047e248f{background:#e2e9f9;border:none}.ce2f30499 .c047e248f:after{display:block}.ce2f30499:hover:not(.cf92da023) .c047e248f{background:#4676d9;border:none}.ce2f30499:hover:not(.cf92da023) .c047e248f:after{border-color:#e2e9f9}.c047e248f{transition:background var(--animation-timing-def) ease;transition-property:background,border;width:1rem;height:1rem;border:.0625rem solid #7b8895;border-radius:.125rem;flex-grow:0;flex-shrink:0;box-sizing:border-box;position:relative}.c047e248f:after{transition:border-color var(--animation-timing-def) ease;display:none;content:'';position:absolute;top:-.125rem;bottom:0;left:0;right:0;margin:auto;border-width:0 .125rem .125rem 0;border-style:solid;border-color:#4676d9;box-sizing:border-box;-webkit-transform:rotate(45deg);transform:rotate(45deg);width:.375rem;height:.625rem}.c39df044e{transition:color var(--animation-timing-def) ease;color:#4f4f4f;margin-left:.625rem;flex-grow:1;flex-shrink:1}.c174c1f96{min-height:1.5rem}.c174c1f96 .c047e248f{margin:.25rem 0}.c174c1f96 .c39df044e{font-size:1rem;font-weight:400;line-height:1.5rem}.c306084d6{min-height:1.25rem}.c306084d6 .c047e248f{margin:.125rem 0}.c306084d6 .c39df044e{font-size:.875rem;font-weight:400;line-height:1.25rem}.cf92da023{opacity:.3}");
var styles = {
  root: 'c579813cb',
  '--disabled': 'cf92da023',
  label: 'c39df044e',
  checkbox: 'c047e248f',
  input: 'c7e5f3f95',
  '--checked': 'ce2f30499',
  '--size-usual': 'c174c1f96',
  '--size-small': 'c306084d6'
};
var PrimaryCheckboxOption = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var classes = props.classes,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement(_core.CoreCheckboxOption, (0, _extends2.default)({
    ref: ref,
    cn: cn
  }, rest));
});
exports.PrimaryCheckboxOption = PrimaryCheckboxOption;
PrimaryCheckboxOption.modes = _core.CoreCheckboxOption.modes;
PrimaryCheckboxOption.propTypes = {
  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryCheckboxOption.defaultProps = {
  classes: {}
};